import { ControlContext } from 'provider/ControlProvider';
import { useContext } from 'react';
import ReactPlayer from 'react-player';

type Props = {
  url: string;
};

export default function Video({ url }: Props) {
  const { setContent } = useContext(ControlContext);
  return (
    <div className='w-full h-full  flex flex-col md:flex-row'>
      <div className='flex-1 mt-48 md:mt-0'>
        <ReactPlayer
          url={url.substring(0, url.length - 3) + 'mp4'}
          controls={true}
          width='100%'
          height='100%'
        />
      </div>
      <div className='w-full md:w-96 h-full bg-zinc-900 relative'>
        <button
          className='absolute top-20 right-5 z-50 text-white text-lg rounded-md p-2 border-2 drop-shadow-md shadow-md'
          onClick={() =>
            setContent({
              index: 0,
              type: 0,
              url: '',
            })
          }
        >
          Back to Map
        </button>
      </div>
    </div>
  );
}
